module.exports = __webpack_public_path__ + "static/media/SVG_think.5fb2614c.svg";